import React from 'react'
import styled from 'styled-components'
import loaderIcon from 'assets/icons/loader.svg'
import Fade from '@mui/material/Fade'

export const StyledLoader = styled.img`
  width: 100px;
  height: 100px;
  position: absolute;
  left: calc(50% - 50px);
  top: calc(50% - 50px);
  animation: spin 2s linear infinite;

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`

interface ILoader {
  loading: boolean
  delay?: number
}

const Loader = (props: ILoader) => {
  const { loading, delay } = props

  return (
    <Fade in={loading} style={{ transitionDelay: loading && delay ? `${delay}ms` : '0ms' }}>
      <div>
        <StyledLoader src={loaderIcon} alt="Loading..." />
      </div>
    </Fade>
  )
}

export default Loader
